import styles from './index.scss'

type PropsType = {
  onChange: (value: number) => void
  list: any[]
  value: number
}

export default function Tabs(props: PropsType) {
  const { onChange, list, value } = props

  return (
    <div className={styles.tabs}>
      {list.map((v: any) => (
        <div
          className={styles.tab}
          key={v.value}
          onClick={() => onChange(v.value)}
        >
          <div
            className={`${styles.box} ${value == v.value ? styles.avtive : ''}`}
          >
            <div className={styles.title}>{v.title}</div>
          </div>
        </div>
      ))}
    </div>
  )
}
